import { BrowserRouter } from "react-router-dom";
import "./App.css";
import RoutesWithAnimation from "./provider/RoutesWithAnimation";
import { theme } from "./theme/Theme";
import { ThemeProvider } from "@mui/material";
import RtlComponent from "./components/RtlComponent";
import ErrorBoundary from "./provider/ErrorBoundaryState";
import { useState } from "react";
import { DraggedItemsProvider } from "./context/DraggedItemsContext";

function App() {
  const [enteredUser, setEnteredUser] = useState(
    localStorage.getItem("user_state") === "REGISTERED" ||
      localStorage.getItem("user_state") === "VERIFIED"
      ? localStorage.getItem("access_token")
      : null
  );
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <ThemeProvider theme={theme}>
      <RtlComponent>
        <BrowserRouter>
          <ErrorBoundary>
            <DraggedItemsProvider>
              <RoutesWithAnimation
                setEnteredUser={setEnteredUser}
                setIsModalOpen={setIsModalOpen}
                isModalOpen={isModalOpen}
                enteredUser={enteredUser}
              />
            </DraggedItemsProvider>
          </ErrorBoundary>
        </BrowserRouter>
      </RtlComponent>
    </ThemeProvider>
  );
}

export default App;
